import { render, staticRenderFns } from "./ImageBanner.vue?vue&type=template&id=38a9a17d&scoped=true&"
import script from "./ImageBanner.vue?vue&type=script&lang=js&"
export * from "./ImageBanner.vue?vue&type=script&lang=js&"
import style0 from "./ImageBanner.vue?vue&type=style&index=0&id=38a9a17d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a9a17d",
  null
  
)

export default component.exports